import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelcaseToSpace'
})
export class CamelcaseToSpacePipe implements PipeTransform {

  transform(value: string, uppercaseFirst: boolean): any {
    const ret = value.replace(/([A-Z])([a-z])/g, ' $1'.toLowerCase() + '$2');
    if (uppercaseFirst) {
      return ret.substr(0, 1).toUpperCase() + ret.substr(1);
    }
    return ret;
  }

}
